import React, { PureComponent } from "react";

import Select from "react-select";

import { Button, ButtonGroup, Dropdown, Icon } from "aible";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCog,
  faChevronLeft,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faEdit,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import CrownIcon from "images/CrownIcon.svg";

import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";

import { UNIFIED_PROJECT_STEPS } from "containers/Business/BusinessReducer";

import styles from "./style.module.css";

export default class MadLibsBox extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { label, bottomLabel, value, onChange, isWide } = this.props;
    return (
      <div className={styles.madlibsItemInput + " " + (isWide ? styles.wide : "")}>
        {label ? <div className={styles.madlibsItemInputLabel}>{label}</div> : <React.Fragment />}
        <LineInput
          isMediumBox
          value={value}
          onChange={(val) => onChange(val)}
          inputStyle={{ fontSize: "13px", maxWidth: "180px" }}
        />
        {bottomLabel ? (
          <div className={styles.madlibsItemInputLabel + " " + styles.isBottomLabel}>{bottomLabel}</div>
        ) : (
          <React.Fragment />
        )}
      </div>
    );
  }
}
